import { Badge, Box, Container, Grid, Image, Skeleton } from '@chakra-ui/react'
import { ParamsSource, type AppInfoMessage } from 'BrokerTsLib/src/dtos'
import { useGetAllAppInfoMessages } from 'BrokerTsLib/src/hooks/useAppInfoMessage'
import { useEffect } from 'react'

import carkulkaDashboardImage from '../../assets/images/carkulka-dashboard-image.webp'
import { Card, CardBody, CardTitle } from '../../components/Card'
import { ProductionGraph } from '../../components/ProductionGraph'
import { Section } from '../../components/Section'
import { NewsList } from '../../containers/news/NewsList'
import { useAuth } from '../../context/AuthContext'
import { useApp } from '../../hooks/useApp'
import { fadeInLeft } from '../../utils/fadeInLeft'
import AnniversaryWidget from './widget/anniversary'
import ConceptsWidget from './widget/concepts'

export const DashboardPage = () => {
  const { product } = useApp()
  const showMessageLimit = 3

  const {
    mutateAsync: getMessages,
    data: dataMessages,
    isPending: isLoading,
  } = useGetAllAppInfoMessages()
  const filter = {
    product: product!,
    pageIndex: 1,
    pageSize: showMessageLimit,
    shown: true,
  }
  const news = (dataMessages?.data?.items ?? []) as AppInfoMessage[]

  useEffect(() => {
    getMessages(filter)
  }, [])

  const msgs = news.sort(
    (a, b) =>
      new Date(b.dateCreatedMember).getTime() -
      new Date(a.dateCreatedMember).getTime(),
  )

  const messagesCount = dataMessages?.data?.totalCount ?? 0

  const { carkulkaUnreadMessages: unreadCount } = useAuth()!

  return (
    <Section>
      <Container>
        <Grid sx={{ gap: { base: 5, md: 8 } }}>
          <Grid
            className="dashboard-header"
            sx={{
              gridTemplateColumns: {
                base: '1fr',
                lg: '2fr 3fr',
                xl: '1fr 2fr',
              },
              gap: 8,
            }}
          >
            <Card sx={{ order: { base: 1, lg: 0 } }}>
              <CardTitle>
                Aktuality
                {unreadCount > 0 && <Badge>{unreadCount}</Badge>}
              </CardTitle>

              <CardBody sx={{ p: 0 }}>
                <Skeleton
                  isLoaded={!isLoading}
                  sx={{ ...(isLoading ? { m: 4, h: 80 } : {}) }}
                >
                  {msgs && (
                    <NewsList
                      news={msgs}
                      showMoreLink={messagesCount > showMessageLimit}
                    />
                  )}
                </Skeleton>
              </CardBody>
            </Card>

            <Box
              sx={{
                display: 'grid',
                placeContent: 'center',
                placeItems: 'center',
              }}
            >
              <Image
                sx={{
                  animation: `${fadeInLeft} 0.5s 1s`,
                  animationFillMode: 'backwards',
                }}
                width={640}
                mt={8}
                pl={{ base: 0, lg: '10%', xl: '15%' }}
                pr={{ base: 0, lg: '30%', xl: '15%' }}
                src={carkulkaDashboardImage}
                alt=""
                aria-hidden
                style={{ mixBlendMode: 'multiply' }}
              />
            </Box>
          </Grid>

          <ConceptsWidget query={{ paramsSource: ParamsSource.AutoRenewed, pageIndex: 1 }} hideIfEmnpty />

          <ConceptsWidget />

          <AnniversaryWidget />

          <ProductionGraph />
        </Grid>
      </Container>
    </Section>
  )
}